import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FopViewType from './fopViews/FopViewType';
import RegularFopView from '../containers/fopViews/RegularFopView';
import SuggestedOrderFopView from './fopViews/SuggestedOrderFopView';

export default class Fop extends Component {
  static propTypes = {
    className: PropTypes.string,
    collectionFopIdx: PropTypes.number,
    fop: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      hash: PropTypes.number.isRequired,
      fopAttributes: PropTypes.object,
    }),
    fopElementsFactory: PropTypes.shape({
      shouldUpdateFopControls: PropTypes.func.isRequired,
      fopViewType: PropTypes.string.isRequired,
    }).isRequired,
    fopType: PropTypes.string,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      offer: PropTypes.object,
    }),
    productsPageRoute: PropTypes.object.isRequired,
    section: PropTypes.object,
    sectionFopIdx: PropTypes.number,
    sectionIdx: PropTypes.number,
  };

  static contextTypes = {
    gtmPageType: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.product !== nextProps.product
      || this.props.fop !== nextProps.fop
      || this.props.collectionFopIdx !== nextProps.collectionFopIdx
      || this.props.sectionFopIdx !== nextProps.sectionFopIdx
      || this.props.sectionIdx !== nextProps.sectionIdx
      || this.props.fopType !== nextProps.fopType
      || this.props.className !== nextProps.className
      || (this.props.fopElementsFactory &&
        this.props.fopElementsFactory.shouldUpdateFopControls(this.props.product.sku, nextProps.fopElementsFactory))
    );
  }

  get productGtmData() {
    const { product, section, collectionFopIdx } = this.props;
    const { gtmPageType } = this.context;

    return {
      // productData
      product,
      section,
      collectionFopIdx,
      gtmPageType,
    };
  }

  get promotionGtmData() {
    const { product, section, collectionFopIdx } = this.props;
    const { gtmPageType } = this.context;

    return {
      // promotionData
      offer: product.offer,
      section,
      collectionFopIdx,
      gtmPageType,
    };
  }

  render() {
    const {
      productGtmData,
      promotionGtmData,
    } = this;
    const {
      className,
      collectionFopIdx,
      fop,
      fopElementsFactory,
      fopType,
      product,
      productsPageRoute,
      pageParameters,
      section,
      sectionFopIdx,
      sectionIdx,
    } = this.props;

    const passProps = {
      className,
      collectionFopIdx,
      fop,
      fopType,
      product,
      productGtmData,
      productsPageRoute,
      pageParameters,
      promotionGtmData,
      section,
      sectionFopIdx,
      sectionIdx,
    };

    switch (fopElementsFactory.fopViewType) {
      case FopViewType.SUGGESTED_ORDER_FOP:
        return (
          <SuggestedOrderFopView {...passProps} />
        );
      case FopViewType.REGULAR_FOP:
      default:
        return (
          <RegularFopView
            {...passProps}
            fopElementsFactory={fopElementsFactory}
            sectionId={section.id}
          />
        );
    }
  }
}
